import styles from "../saveSearch.module.scss";
import classNames from "classnames";

const Modal = ({ title, loader, children, onClose, isOpen, footerComponent, size }) => {
  const modalSizes = classNames({
    [styles["modal_md"]]: size === "medium",
    [styles["modal_sm"]]: size === "small",
    [styles["modal_lg"]]: size === "large",
    [styles["modal_xl"]]: size === "extraLarge",
  });
  return (
    <>
      <div className={styles.modal_overlay} style={{ display: isOpen ? "flex" : "none" }}>
        <div className={`${styles.modal_content} ${modalSizes}`}>
          <div className={styles.modal_header}>
            <span className={styles.modal_title}>{title}</span>
            <svg className="cursor-pointer" onClick={onClose} xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#667085">
              <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
            </svg>
          </div>
          <div className={`${loader ? `${styles.modal_body} tw-flex tw-items-center tw-justify-center` : `${styles.modal_body}`}`}>{children}</div>
          {footerComponent && <div className={styles.modal_footer}>{footerComponent}</div>}
        </div>
      </div>
    </>
  );
};

Modal.defaultProps = {
  size: "large",
};
export default Modal;
